import "core-js/fn/promise";
import HTTP, { Request } from "superagent";
import { getCSRF } from "@shared/core/csrf";

const DEFAULT_TIMEOUT = 30;

const baseHeaders = {
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest",
};

Request.prototype.addAbortSignal = function(signal) {
  this.abortSignalListener =
    this.abortSignalListener ||
    (() => {
      this.abort();
    });
  this.abortSignals = this.abortSignals || [];
  if (signal && signal.addEventListener) {
    if (!this.__requestEnded) {
      signal.addEventListener("abort", this.abortSignalListener);
      this.abortSignals.push(signal);
    }
  } else {
    console.warn("signal 需要是一个 event emitter");
  }
};

const originalClearTimeout = Request.prototype.clearTimeout;
Request.prototype.clearTimeout = function() {
  const r = originalClearTimeout.call(this);
  this.__requestEnded = true;
  if (this.abortSignals && this.abortSignalListener) {
    this.abortSignals.forEach(signal => signal.removeEventListener("abort", this.abortSignalListener));
  }
  return r;
};

Request.prototype.configBase = function(headers = {}, timeout = DEFAULT_TIMEOUT) {
  const csrfHeaders = {};

  if (this.method === "POST") {
    const csrf = getCSRF();
    csrfHeaders[csrf.header] = csrf.token;
  }
  return this.set({
    ...csrfHeaders,
    ...baseHeaders,
    ...headers,
  }).timeout(timeout * 1000);
};

hackForXohr(Request);

export function get(url, data, config = {}) {
  return HTTP.get(url)
    .query(data)
    .configBase(config.headers, config.timeout);
}

export function post(url, data, config = {}) {
  return HTTP.post(url)
    .send(data)
    .configBase(config.headers, config.timeout);
}

export default { get, post };

function hackForXohr(Request) {
  Request.prototype._finalizeQueryStringBackupForRohr = Request.prototype._finalizeQueryString;

  Request.prototype._finalizeQueryString = function rohrFinalizeQueryString() {
    this._finalizeQueryStringBackupForRohr();
    if (typeof window === "undefined") return this;
    const Rohr = window.Rohr_Opt;
    if (!Rohr || !Rohr.reload) return this;
    if (/[&?]_token=/.test(this.url)) return this;
    try {
      const url = window.location.origin + this.url;
      const _token = Rohr.reload(url);
      this.url += (url.indexOf("?") > -1 ? "&" : "?") + "_token=" + encodeURIComponent(_token);
    } catch (e) {
      window.setTimeout(function() {
        throw e;
      }, 23);
      return this;
    }
  };
}
